import React from 'react';
import { LogoImage } from './Logo/styled/LogoImage';
import { LogoWrapper } from './Logo/styled/LogoWrapper';
import { addSubdirectoryToPath } from '../../../util/getConfig';
import store from '../../../store/store';

export const Logo = ({ logoWidth }) => {
  const { config } = store.getState();
  const { APPLICATION_ASSETS } = config;
  const logo = APPLICATION_ASSETS?.logo || 'mclinic-logo.png';
  const path = addSubdirectoryToPath(`/meta/images/${logo}`);

  return (
    <LogoWrapper>
      <LogoImage src={path} title={`License ID: ${config.licenseID}`} logoWidth={logoWidth} />
    </LogoWrapper>
  );
};

export default Logo;
